module.exports = __webpack_public_path__ + "img/tailwindui.b9a29637.gif";